import React, { Fragment } from "react";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import { forgetPassword, sendOtp } from "../../../../services/authService";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useLocation, useNavigate } from "react-router-dom";

const validation = {
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const ResetPasswordForm = ({ email }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const navigate = useNavigate();
  const location = useLocation();

  // const {
  //   mutate,
  //   error: signUpError,
  //   isPending: signUpPending,
  //   data: signUpData,
  // } = useMutation({
  //   mutationFn: async (val) => {
  //     return await forgetPassword({
  //       ...val,
  //       email: location?.state ? location?.state?.email : email,
  //     });
  //   },
  //   onSuccess: async (res) => {
  //     if (res?.status === 200 || res?.status === 201) {
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       window.location.href = window.location.origin + "/authentication";
  //     } else {
  //       toast.warning(res?.message || res?.error);
  //     }
  //   },
  // });

  const resendOtp = async () => {
    if (!location?.state?.email && !email) {
      toast.error("Email is missing. Please try again.");
      return;
    }

    try {
      const response = await sendOtp({
        email: location?.state ? location?.state?.email : email,
      });

      if (response?.status === 200 || response?.status === 201) {
        setFieldsValue({ otp: "" });
        toast.success("OTP resent successfully!");
      } else {
        toast.warning(response?.message || "Failed to resend OTP.");
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP.");
    }
  };

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => handleSubmit(event, () => {})}
    >
      <Fragment>
        <div className="mt-2 relative">
          <OtpInput
            label={"Enter the secure code from your email"}
            handleOtpChange={(val) =>
              handleChange({
                target: { value: val, name: "otp" },
              })
            }
            inputName="otp"
            labelChildClass={
              "!h-12 !rounded-lg !border-white !bg-transparent !text-white placeholder:!text-white focus:!border-primary"
            }
            {...formValidate(errors, "otp")}
          />
        </div>
        <div className="flex justify-center">
          <Button
            buttonClasses={"absolute -bottom-[20px]"}
            buttonLabel={"Resend Code"}
            buttonLabelClasses={"whitespace-nowrap px-3"}
            buttonFunction={resendOtp}
          />
        </div>
        <div className="mt-2">
          <Input
            label={"Password"}
            inputPlaceholder={"Enter Your Password"}
            labelClasses={"!text-xs"}
            inputType={"password"}
            value={values.password}
            inputName={"password"}
            onChange={handleChange}
            {...formValidate(errors, "password")}
          />
        </div>

        <div className="mt-2">
          <Input
            label={"Confirm Password"}
            inputPlaceholder={"Enter Confirm Password"}
            labelClasses={"!text-xs"}
            inputType={"password"}
            value={values.confirmPassword}
            inputName={"confirmPassword"}
            onChange={handleChange}
            {...formValidate(errors, "confirmPassword")}
          />
        </div>
      </Fragment>
      <div className="relative">
        <Button
          buttonLabel={"Reset Password"}
          buttonType="submit"
          buttonLabelClasses={"!text-lg !font-semibold"}
          buttonClasses={"!w-full !h-12 !rounded-lg"}
          // loading={signUpPending}
          // isDisable={signUpPending}
          buttonIconPosition="left"
        />
      </div>
    </form>
  );
};

export default ResetPasswordForm;
